import * as React from 'react';
import classNames from 'classnames';

import styles from './Skeleton.module.scss';


type SkeletonProps = {
    width?: number | string;
    height?: number | string;
    className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ width, height, className }) => {

    return (
        <div className={classNames(styles.skeleton, className)} style={{ width, height }} />
    );
}
